import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';
import {
    MONTHLY_NET_SALES_REPORT_GET_START,
    MONTHLY_NET_SALES_REPORT_GET_SUCCESS,
    MONTHLY_NET_SALES_REPORT_GET_ERROR,
    MonthlyNetSalesReportAction
} from './MonthlyNetSalesReportActionsTypes';
import { MonthlyNetSalesReportDto } from './MonthlyNetSalesReportDto';
import { convertToMonthlyNetSalesReport } from './monthlyNetSalesReportConverter';
import { MonthlyNetSalesReport } from 'model/MonthlyNetSalesReport';

export const getMonthlyNetSalesReport = (
    year?: number
): ThunkAction<void, null, null, MonthlyNetSalesReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId } = store.getState().login.auth;
        let url = `/monthly_net_sales_report?marketplace_id=${marketplaceId}`;
        if (year) url += `&year=${year}`;

        try {
            const response: AxiosResponse<MonthlyNetSalesReportDto> = await ApiClient.get(
                url,
                createTokenConfig(store.getState().login.auth.token!)
            );
            dispatch(getSuccess(convertToMonthlyNetSalesReport(response.data)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Too many records to display. Please try a shorter date range.'));
            }
        }
    };
};

const getStart = (): MonthlyNetSalesReportAction => ({
    type: MONTHLY_NET_SALES_REPORT_GET_START
});

const getSuccess = (report: MonthlyNetSalesReport): MonthlyNetSalesReportAction => ({
    type: MONTHLY_NET_SALES_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): MonthlyNetSalesReportAction => ({
    type: MONTHLY_NET_SALES_REPORT_GET_ERROR
});
